import React from "react";
import "./style.css";
import ReactHtmlParser from "react-html-parser";

function Recruitment(props) {
  const { content } = props.data;
  console.log(content);
  return (
    <div className="content_container">
     
      {
        content.map((val)=>{
          return (
            <div className="row">
            <div className="card">
                    <h6 className="card-title">{val.title}</h6>
                    <div className="card-content row">
                        <div className="col l6  s12">
                            <p className="main-paragraph">{ReactHtmlParser(val.description)}</p>
                        </div>
                        <div className="col l6  s12 img_container" >
                            <img className="materialboxed" src={val.full_path} className="responsive_img" />
                        </div>
                    </div>
            </div>
                
        </div>
          )
        })
    }
     
    </div>
  );
}
export default Recruitment;
